import "magnific-popup";

$(document).ready(function ($) {
  $(".js-video-popup").magnificPopup({
    type: "iframe",
    iframe: {
      markup:
        '<div class="mfp-iframe-scaler">' +
        '<div class="mfp-close">x</div>' +
        '<iframe class="mfp-iframe" frameborder="0" allowfullscreen allow="autoplay"></iframe>' +
        "</div>",
      patterns: {
        youtube: {
          src: "https://www.youtube.com/embed/%id%?&autoplay=1", // URL that will be set as a source for iframe.
        },
        vimeo: {
          src: "https://player.vimeo.com/video/%id%?playsinline=1&autoplay=1&byline=0&autopause=0",
        },
      },
    },
  });
});
